import { render, staticRenderFns } from "./regionais.vue?vue&type=template&id=a09c7040"
import script from "./regionais.vue?vue&type=script&lang=js"
export * from "./regionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports